<div class="badge">
<span class="badge-content">{{ packageName }}</span>
</div>
